import { Link } from "react-router-dom";
import { collections } from "@/mocks/collections";
import { films } from "@/mocks/films";
import SectionHeading from "@/components/base/SectionHeading";

const CollectionBlock = () => {
  const [main, ...rest] = collections;

  return (
    <section className="w-full bg-background-100/70">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-8 md:py-20">
        <SectionHeading
          eyebrow="Editor's Choice"
          title="编辑精选专题"
          description="编辑部根据主题、影像语言与资料完整度整理的策展合集，帮你按兴趣成组观看。"
          action={
            <Link
              to="/category?sort=popular"
              className="inline-flex items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              更多专题
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-right-line text-xs" />
              </span>
            </Link>
          }
        />

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-12">
          <Link
            to={`/detail/${main.filmIds[0]}`}
            className="group relative col-span-1 overflow-hidden rounded-lg lg:col-span-7"
          >
            <div className="relative h-[280px] w-full md:h-[380px]">
              <img
                src={main.cover}
                alt={main.title}
                title={`${main.title} 编辑精选专题`}
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.03]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/35 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
                <span className="inline-flex rounded-full bg-background-50/95 px-2.5 py-1 text-[11px] font-medium text-primary-700">
                  本期主推 · {main.editor}
                </span>
                <h3 className="mt-3 font-heading text-xl font-bold text-background-50 md:text-2xl">
                  {main.title}
                </h3>
                <p className="mt-2 max-w-lg text-sm leading-relaxed text-background-200/85">
                  {main.reason}
                </p>
                <div className="mt-4 flex flex-wrap items-center gap-2">
                  {main.filmIds.map((id) => {
                    const film = films.find((item) => item.id === id);
                    if (!film) return null;
                    return (
                      <span
                        key={id}
                        className="rounded-full border border-background-50/25 px-2.5 py-1 text-[11px] text-background-100/85"
                      >
                        《{film.title}》
                      </span>
                    );
                  })}
                </div>
              </div>
            </div>
          </Link>

          <div className="col-span-1 flex flex-col gap-5 lg:col-span-5">
            {rest.map((collection) => {
              const firstFilm = films.find((film) => film.id === collection.filmIds[0]);
              return (
                <Link
                  key={collection.id}
                  to={firstFilm ? `/detail/${firstFilm.id}` : "/category"}
                  className="group flex flex-1 gap-4 rounded-lg border border-background-200/80 bg-background-50 p-3 transition-colors hover:border-primary-300"
                >
                  <div className="h-[104px] w-[104px] shrink-0 overflow-hidden rounded-md md:h-[116px] md:w-[116px]">
                    <img
                      src={collection.cover}
                      alt={collection.title}
                      title={`${collection.title} 专题`}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="flex min-w-0 flex-col justify-center">
                    <h4 className="font-heading text-[15px] font-semibold leading-snug text-foreground-950 group-hover:text-primary-700">
                      {collection.title}
                    </h4>
                    <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                      {collection.subtitle}
                    </p>
                    <p className="mt-2 flex items-center gap-1.5 text-[11px] text-foreground-400">
                      <span className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className="ri-stack-line" />
                      </span>
                      {collection.filmIds.length} 部作品
                      <span className="mx-1">·</span>
                      {collection.editor}
                    </p>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CollectionBlock;